export const STORAGE_KEY = "viewed_items";

export function getViewedItems(): string[] {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

export function saveViewedItem(id: string) {
  const list = getViewedItems();
  if (!list.includes(id)) {
    const updated = [...list, id];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  }
}

export function isViewedItem(id: string): boolean {
  return getViewedItems().includes(id);
}
